var oa = Object.defineProperty, sa = Object.defineProperties;
var ra = Object.getOwnPropertyDescriptors;
var he = Object.getOwnPropertySymbols;
var ia = Object.prototype.hasOwnProperty, ua = Object.prototype.propertyIsEnumerable;
var Ne = (_, f, g) => f in _ ? oa(_, f, { enumerable: !0, configurable: !0, writable: !0, value: g }) : _[f] = g, W = (_, f) => {
  for (var g in f || (f = {}))
    ia.call(f, g) && Ne(_, g, f[g]);
  if (he)
    for (var g of he(f))
      ua.call(f, g) && Ne(_, g, f[g]);
  return _;
}, $ = (_, f) => sa(_, ra(f));
var C = (_, f, g) => new Promise((m, Z) => {
  var re = (z) => {
    try {
      P(g.next(z));
    } catch (b) {
      Z(b);
    }
  }, p = (z) => {
    try {
      P(g.throw(z));
    } catch (b) {
      Z(b);
    }
  }, P = (z) => z.done ? m(z.value) : Promise.resolve(z.value).then(re, p);
  P((g = g.apply(_, f)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { checkMenuPermissionSync as na, reqGetCurrentUser as _e, getPermissionListSync as da, getDict as Se } from "@oppein/op-utils";
import pa from "../../node_modules/.pnpm/dayjs@1.10.7/node_modules/dayjs/dayjs.min.js";
import ca from "../../com-components/op-region-select/RegionSelect.vue.js";
import "../../com-components/op-region-select/RegionSelect.vue2.js";
import va from "../brand-category-selector/brandCategorySelector.ce.vue.js";
import { postSelectOrgRightListByCon as ma } from "../../request/internal/org/selectOrgRightListByCon/post.js";
import { postCreateColorProofing as ga } from "../../request/designordercenter/productionOrder/specialApply/createColorProofing/post.js";
import { postCreateRelocateBase as ya } from "../../request/designordercenter/productionOrder/specialApply/createRelocateBase/post.js";
import { postCreateCarrierChange as fa } from "../../request/designordercenter/productionOrder/specialApply/createCarrierChange/post.js";
import { postCreateBigFamilySpecialProcess as ba } from "../../request/designordercenter/productionOrder/specialApply/createBigFamilySpecialProcess/post.js";
import { postCreateBaseSelfPickup as wa } from "../../request/designordercenter/productionOrder/specialApply/createBaseSelfPickup/post.js";
import { postCreateSpecialShipping as ka } from "../../request/designordercenter/productionOrder/specialApply/createSpecialShipping/post.js";
import { postGetPageListByQry as Ca } from "../../request/designordercenter/productionOrder/receiver/getPageListByQry/post.js";
import { postGetEsPageListByQry as ha } from "../../request/designordercenter/productionOrder/getEsPageListByQry/post.js";
import { postPage as Na } from "../../request/apigateway.oppein.com/crmapi/internal/customer/page/post.js";
import { postQuery as _a } from "../../request/salesEngineeringSignApply/query/post.js";
import { postCreateDjjSpecialProcess as Sa } from "../../request/bpmSpecialFlow/createDjjSpecialProcess/post.js";
import { useDialog as Ia } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/composables.js";
import B from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import L from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import { toDisplayString as Ie } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import ze from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
import za from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/RadioGroup.js";
import Ta from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tabs/src/Tabs.js";
import Te from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tabs/src/TabPane.js";
import { defineComponent as xa, useTemplateRef as xe, computed as ve, openBlock as N, createElementBlock as j, createElementVNode as c, createVNode as r, withCtx as u, Fragment as V, createBlock as se, createTextVNode as v, createCommentVNode as S, h as Ra, watch as Ba } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as ja } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as d, unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import La from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ma from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import Re from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import y from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import H from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import me from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/pagination/src/Pagination.js";
import Da from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Pa = { class: "tw:mb-4" }, Ua = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Aa = {
  key: 0,
  class: "tw:flex tw:items-center tw:gap-2 tw:mb-4"
}, Ka = { class: "tw:flex tw:gap-2 tw:flex-1" }, Oa = { class: "tw:mb-4" }, Wa = { class: "tw:flex tw:justify-end tw:items-center tw:mt-3 tw:gap-2" }, $a = { class: "tw:text-gray-500" }, Va = {
  key: 1,
  class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4"
}, Ja = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, Ga = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Fa = {
  key: 1,
  style: { "margin-left": "20px" }
}, Ya = { class: "tw:flex tw:justify-end tw:mt-3" }, Ea = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, Qa = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, qa = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Ha = { class: "tw:flex tw:items-center tw:gap-2 tw:mb-2" }, Za = { class: "tw:mb-2 tw:text-sm" }, Xa = { class: "tw:flex tw:justify-end tw:mt-3" }, et = { class: "tw:flex tw:justify-center tw:gap-4 tw:mt-4" }, At = /* @__PURE__ */ xa({
  __name: "mallSpApprovalTrigger.ce",
  emits: ["navigate"],
  setup(_, { expose: f, emit: g }) {
    const m = ja(), Z = Ia(), re = g;
    let p = null;
    const P = xe(
      "brandCategorySelectorRef"
    ), z = xe("triggerContainer"), b = d(!1), h = d(!1), ge = d(!1), J = d(!1), T = d(null), w = d({ code: "" }), ye = d([]), Be = ve(() => Me(ye.value)), je = ve(
      () => Be.value.map((a) => ({ label: a.label, value: a.code }))
    ), Le = [
      { permission: "BpmProcessCarrier", code: "bpm_process_carrier" },
      { permission: "BpmProcessDsdyJudge", code: "bpm_process_dsdy_judge" },
      { permission: "BpmProcessJJSpecialProcess", code: "bpm_process_djjspecial_judge" },
      { permission: "BpmProcessRelocatebaseJudge", code: "bpm_process_relocatebase_judge" },
      { permission: "BpmProcessSelfPickupApplication", code: "bpm_process_baseselfpickup_judge" },
      { permission: "BpmProcessSpecialShipping", code: "bpm_process_specialshipping_judge" }
    ];
    function Me(a) {
      return a.filter((e) => {
        const l = Le.find((t) => t.code === e.code);
        return l ? na({ permission: l.permission }) : !0;
      });
    }
    const X = d([]), x = d(null), G = d([]), De = [
      { type: "selection" },
      { title: "k3扣费账户名称", key: "orgK3Name", width: 180 },
      { title: "k3编码", key: "orgK3Code", width: 180 },
      { title: "经销部", key: "orgBelongClassifySalesName" },
      { title: "线别", key: "orgBelongClassifyName" },
      { title: "商场管理员", key: "orgStoreAdminName" }
    ], Pe = [
      { type: "selection" },
      { title: "所属事业线", key: "orgBelongMarketClassifyName" },
      { title: "所属经销部", key: "orgBelongDepartmentName" },
      { title: "经销部", key: "orgBelongClassifySalesName" },
      { title: "市场级别", key: "orgMarketRank" },
      { title: "商场管理员", key: "orgStoreAdminName" }
    ];
    function Ue() {
      return C(this, null, function* () {
        const a = yield _e();
        T.value = a;
        const e = yield ma({ orgNo: a.orgNo });
        X.value = e || [];
      });
    }
    function fe(a) {
      G.value = a.length ? [a[a.length - 1]] : [], x.value = X.value.find((e) => e.orgMarketManageRightId === G.value[0]) || null;
    }
    const F = d(!1), ie = d([]), Y = d(null), E = d([]), ue = d([]), i = d({
      shopList: [],
      isDryWarehouse: 0,
      baseCode: "",
      base: "",
      region: "",
      address: "",
      orgId: "",
      total: 0,
      pageNo: 1,
      pageSize: 100
    }), Ae = [
      { type: "selection", fixed: "left", width: 55 },
      { title: "收货地址ID", key: "id" },
      { title: "收货人", key: "receiver" },
      { title: "收货电话", key: "receiverTel" },
      { title: "收货行政区划", key: "regionName" },
      { title: "收货详细地址", key: "address" },
      {
        title: "品牌品类",
        key: "brandCategoryList",
        render(a) {
          return Ra(
            "button",
            {
              class: "tw:text-blue-500 tw:cursor-pointer tw:bg-transparent tw:border-none tw:underline",
              onClick: () => Ke(a)
            },
            a.brandCategoryList.length ? a.brandCategoryList.map((e) => e.brandName + e.categoryName).join(";") : "请添加品牌品类"
          );
        }
      }
    ];
    function Ke(a) {
      return C(this, null, function* () {
        var l, t;
        const e = yield (t = P.value) == null ? void 0 : t.open({
          orgId: ((l = T.value) == null ? void 0 : l.orgId) || "",
          selectedItems: a.brandCategoryList
        });
        e && Array.isArray(e) && (a.brandCategoryList = e);
      });
    }
    function Oe() {
      return C(this, null, function* () {
        const a = yield Se("ROOT_MTDS_production_base");
        ie.value = (a || []).map((e) => ({
          label: e.label,
          value: e.code,
          remark: e.remark || e.remarks || ""
        }));
      });
    }
    function ne(a) {
      var l, t;
      const e = ie.value.find((n) => n.value === a);
      Y.value = e ? { code: e.value, name: e.label, remark: e.remark || "" } : null, i.value.baseCode = ((l = Y.value) == null ? void 0 : l.code) || "", i.value.base = ((t = Y.value) == null ? void 0 : t.name) || "", i.value.region = "", i.value.address = "", E.value = [], i.value.shopList = [], ue.value = [], i.value.total = 0;
    }
    function ee(a, e) {
      return C(this, null, function* () {
        var l;
        if (e) {
          if (!Y.value) {
            m.warning("请选择【基地】");
            return;
          }
          i.value.shopList = [];
        }
        i.value.pageNo = a, h.value = !0;
        try {
          const t = {
            pageNo: a,
            pageSize: i.value.pageSize,
            // base: shopParams.value.baseCode, 后端接口没有接收
            region: i.value.region === "1" ? "" : i.value.region,
            address: i.value.address,
            orgId: (l = T.value) == null ? void 0 : l.orgId
          }, n = yield Ca(t);
          n && n.records && (E.value = (n.records || []).map((I) => $(W({}, I), {
            keyId: `${I.id}-${I.brand}-${I.category}`,
            brandCategoryList: []
          })), i.value.total = n.total || 0);
        } catch (t) {
          console.error("查询收货地址失败:", t), E.value = [], i.value.total = 0;
        } finally {
          h.value = !1;
        }
      });
    }
    function We(a) {
      ue.value = a, i.value.shopList = a.map((e) => E.value.find((l) => l.keyId === e)).filter(Boolean);
    }
    function $e(a) {
      i.value.pageSize = a, ee(1);
    }
    function de() {
      i.value.region = "", i.value.address = "", F.value = !1;
    }
    function Ve() {
      return C(this, null, function* () {
        if (!i.value.baseCode) {
          m.warning("请选择基地");
          return;
        }
        if (!i.value.shopList.length) {
          m.warning("请选择收货地址");
          return;
        }
        if (i.value.shopList.some((a) => !a.brandCategoryList.length)) {
          m.warning("需要发起承运商申请的收货地址请选择品牌品类");
          return;
        }
        if (w.value.code === "bpm_process_carrier") {
          const a = i.value.shopList.some(
            (n) => n.category === "category_jinshumenchuang"
          ), e = i.value.shopList.some(
            (n) => n.category !== "category_jinshumenchuang"
          );
          if (a && e) {
            m.warning("金属门窗品类不能与其他品类一起发起");
            return;
          }
          const l = i.value.shopList.some(
            (n) => n.category === "category_jinshumenchuang"
          ), t = i.value.shopList.some(
            (n) => n.category !== "category_jinshumenchuang"
          );
          if (l && t) {
            m.warning("装甲门品类不能与其他品类一起发起");
            return;
          }
        }
        if (i.value.shopList.some((a) => !a.address)) {
          const a = i.value.shopList.filter((e) => !e.address).map((e) => e.shopName);
          Z.warning({
            title: "提示",
            content: `所选的【${a.join("、")}】门店无配置默认收货地址，无法发起申请！请确认是否跳转到收货地址管理或重新选择门店发起`,
            positiveText: "跳转收货地址管理",
            negativeText: "取消",
            onPositiveClick: () => {
              re("navigate", "delivery-address-management");
            }
          });
          return;
        }
        yield Je();
      });
    }
    function Je() {
      return C(this, null, function* () {
        var e;
        const a = {
          isDryWarehouse: String(i.value.isDryWarehouse),
          baseCode: ((e = Y.value) == null ? void 0 : e.remark) || "",
          //shopParams.value.baseCode,
          base: i.value.base,
          receiverInfoList: i.value.shopList.reduce(
            (l, { brandCategoryList: t, id: n }) => l.concat(
              t.map(({ brand: I, category: O }) => ({ receiverId: n, brand: I, category: O }))
            ),
            []
          )
        };
        h.value = !0;
        try {
          const l = yield fa(a);
          l && (m.success("提交申请成功"), b.value = !1, ne(""), de(), window.open(l, "_blank"), p == null || p(!0));
        } catch (l) {
          console.error("提交承运商申请失败:", l);
        } finally {
          h.value = !1;
        }
      });
    }
    function be() {
      b.value = !1, ne(""), de(), p == null || p(!1);
    }
    function Ge() {
      return C(this, null, function* () {
        var l;
        if (!((l = x.value) != null && l.orgMarketManageRightId)) {
          m.warning("请选择K3扣费账户");
          return;
        }
        const a = x.value, e = yield ga({
          orgK3Name: a.orgK3Name,
          orgK3Code: a.orgK3Code,
          orgBelongClassifySalesName: a.orgBelongClassifySalesId,
          orgBelongClassifyId: a.orgBelongClassifyId,
          orgBelongClassifyName: a.orgBelongClassifyName
        });
        e && (window.open(e, "_blank"), b.value = !1, K(), p == null || p(!0));
      });
    }
    const pe = d([]), U = d(null), ce = d([]), we = d(0), s = d({
      customerName: "",
      customerTel: "",
      serviceId: "",
      serviceNo: "",
      orgId: "",
      pageSize: 20,
      pageNo: 1,
      isRelationOrder: 0,
      isTable: 0,
      orderId: "",
      businessType: "business_serviceNo",
      businessId: "",
      customerId: ""
    }), Fe = ve(() => [
      { type: "selection", width: 40, fixed: "left" },
      {
        title: s.value.businessType === "business_applyCode" ? "下单申请号" : "服务号",
        key: s.value.businessType === "business_applyCode" ? "applyCode" : "serviceNo"
      },
      { title: "客户姓名", key: "customerName" },
      {
        title: "客户电话",
        key: s.value.businessType === "business_applyCode" ? "customerPhone" : "customerTel"
      },
      {
        title: "客户行政区划",
        key: s.value.businessType === "business_applyCode" ? "customerRegion" : "customerRegionText"
      },
      { title: "详细地址", key: "customerAddress" },
      ...s.value.businessType === "business_applyCode" ? [] : [
        { title: "导购", key: "salesman" },
        { title: "所属门店", key: "shopName" }
      ],
      { title: "创建人", key: "creator" },
      {
        title: "创建时间",
        key: "createDt",
        render(a) {
          return pa(a.createDt).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    ]);
    function Ye(a) {
      const e = a[a.length - 1];
      ce.value = e ? [e] : [], U.value = e && pe.value.find(
        (l) => s.value.businessType === "business_applyCode" ? l.id === e : l.serviceNo === e
      ) || null;
    }
    function Ee(a) {
      s.value.pageSize = a, ae(1);
    }
    function ae(a) {
      return C(this, null, function* () {
        var l, t, n, I, O;
        if (s.value.pageNo = a, !((l = T.value) != null && l.orgId) && !s.value.customerTel && !s.value.customerName && !s.value.serviceNo) {
          if (((t = T.value) == null ? void 0 : t.marketId) === "1")
            return;
          m.warning("请输入查询条件");
          return;
        }
        ((n = T.value) == null ? void 0 : n.marketId) !== "1" && (s.value.orgId = ((I = T.value) == null ? void 0 : I.orgId) || "");
        const e = {
          customerName: s.value.customerName,
          customerTel: s.value.customerTel,
          serviceId: s.value.serviceId,
          serviceNo: s.value.serviceNo,
          orgId: s.value.orgId,
          pageNo: s.value.pageNo,
          pageSize: s.value.pageSize
        };
        try {
          const R = s.value.businessType === "business_applyCode" ? yield _a({
            orgId: ((O = T.value) == null ? void 0 : O.orgId) || "",
            customerId: s.value.customerId,
            searchKeyWord: s.value.businessId,
            pageNum: s.value.pageNo,
            pageSize: s.value.pageSize
          }) : yield Na(e);
          pe.value = (R == null ? void 0 : R.records) || [], we.value = (R == null ? void 0 : R.total) || 0;
        } catch (R) {
          console.error("查询服务号失败:", R);
        }
      });
    }
    const te = d(null);
    function Qe() {
      return C(this, null, function* () {
        var a;
        if (!U.value) {
          m.warning("请选择服务号");
          return;
        }
        if (te.value === null && s.value.orderId) {
          m.warning("请先选择是否miform客户");
          return;
        }
        if (s.value.businessType === "business_applyCode" && !s.value.businessId) {
          m.warning("下单申请号不能为空");
          return;
        }
        h.value = !0;
        try {
          const e = {
            customerName: U.value.customerName,
            isMiformCustomer: (a = te.value) != null ? a : void 0,
            isTable: s.value.isTable || 0,
            isRelationOrder: s.value.isRelationOrder || 0,
            orderId: s.value.orderId || ""
          }, l = s.value.businessType === "business_applyCode" ? yield Sa($(W({}, e), {
            applyCode: s.value.businessId
          })) : yield ba($(W({}, e), {
            serviceId: U.value.serviceId,
            serviceNo: U.value.serviceNo
          }));
          (l == null ? void 0 : l.status) === !0 ? (m.success("操作成功！"), b.value = !1, K(), p == null || p(!0), window.open(l == null ? void 0 : l.data, "_blank")) : m.error((l == null ? void 0 : l.message) || "操作失败！");
        } catch (e) {
          console.error("发起大家居特殊工艺失败:", e);
        } finally {
          h.value = !1;
        }
      });
    }
    function qe() {
      return C(this, null, function* () {
        var e;
        if (!((e = x.value) != null && e.orgMarketManageRightId)) {
          m.warning("请选择审核人");
          return;
        }
        const a = yield ya({
          orgMarketRank: x.value.orgMarketRank,
          orgMarketRankName: x.value.orgMarketRankName,
          orgStoreAdminAccount: x.value.orgStoreAdminAccount,
          orgStoreAdminId: x.value.orgStoreAdminId,
          orgStoreAdminName: x.value.orgStoreAdminName
        });
        a && (window.open(a, "_blank"), b.value = !1, K(), p == null || p(!0));
      });
    }
    const Q = d("retail"), M = d([]), D = d([]), q = d([]), k = d({ pageNo: 1, pageSize: 20, total: 0 }), A = d({
      searchKeywordByBaseSelfPickup: "",
      searchProductionOrderContractNo: "",
      pageNo: 1,
      pageSize: 20,
      orderCategory: "LSD",
      syncStatus: 1,
      orderDescs: [
        { col: "createDt", desc: !0 },
        { col: "no", desc: !0 }
      ],
      applyCode: ""
    }), le = d({
      applyNo: "",
      searchProductionOrderContractNo: "",
      pageNo: 1,
      pageSize: 20
    }), He = [
      { type: "selection", width: 55 },
      { title: "合同自编号", key: "productionOrderContractNo", minWidth: 180 },
      { title: "订单类别", key: "orderTypeName", minWidth: 80 },
      { title: "订单状态", key: "statusName", minWidth: 100 },
      { title: "产品渠道", key: "productChannelName", minWidth: 100 },
      { title: "客户姓名", key: "customerName", minWidth: 100 },
      { title: "客户电话", key: "customerTel", minWidth: 100 },
      { title: "订单编号", key: "no", minWidth: 150 },
      { title: "品牌", key: "brandName", minWidth: 80 },
      { title: "品类", key: "categoryName", minWidth: 100 }
    ];
    function ke(a) {
      return a.id || a.orderId || a.contractNo;
    }
    function Ze(a) {
      q.value = a, D.value = a.map((e) => M.value.find((l) => ke(l) === e)).filter(Boolean);
    }
    function Xe() {
      D.value = [], q.value = [], M.value = [], k.value = { pageNo: 1, pageSize: 20, total: 0 };
    }
    function ea(a) {
      k.value.pageSize = a, k.value.pageNo = 1, oe(1);
    }
    function oe(a) {
      return C(this, null, function* () {
        k.value.pageNo = a, h.value = !0;
        try {
          const e = Q.value === "retail" ? $(W({}, A.value), { pageNo: a, pageSize: k.value.pageSize }) : $(W({}, A.value), {
            orderCategory: "GCD",
            searchKeywordByBaseSelfPickup: "",
            pageNo: a,
            pageSize: k.value.pageSize
          }), l = yield ha(e);
          l && l.records ? (M.value = l.records || [], k.value.total = l.total || 0) : (M.value = [], k.value.total = 0);
        } catch (e) {
          console.error("搜索失败:", e);
        } finally {
          h.value = !1;
        }
      });
    }
    function aa() {
      b.value = !1, M.value = [], D.value = [], q.value = [], p == null || p(!1);
    }
    function ta() {
      return C(this, null, function* () {
        if (!D.value.length) {
          m.warning("请勾选数据");
          return;
        }
        h.value = !0;
        try {
          let a = null;
          w.value.code === "bpm_process_specialshipping_judge" ? a = ka : a = wa;
          const e = D.value.map((t) => t.no), l = yield a({
            orderCategory: Q.value === "retail" ? "LSD" : "GCD",
            orderNoList: e
          });
          l && (m.success("发起成功"), b.value = !1, window.open(l, "_blank"), p == null || p(!0));
        } catch (a) {
          console.error("发起申请失败:", a);
        } finally {
          h.value = !1;
        }
      });
    }
    function Ce(a) {
      switch (w.value.code = a, x.value = null, G.value = [], Q.value = "retail", M.value = [], D.value = [], q.value = [], k.value = { pageNo: 1, pageSize: 20, total: 0 }, a) {
        case "bpm_process_dsdy_judge":
        case "bpm_process_relocatebase_judge":
          Ue();
          break;
        case "bpm_process_djjspecial_judge":
          ae(1);
          break;
      }
    }
    function K() {
      b.value = !1, U.value = null, ce.value = [], s.value = {
        customerName: "",
        customerTel: "",
        serviceId: "",
        serviceNo: "",
        orgId: "",
        pageSize: 20,
        pageNo: 1,
        isRelationOrder: 0,
        isTable: 0,
        orderId: "",
        businessType: "business_serviceNo",
        businessId: "",
        customerId: ""
      }, p == null || p(!1);
    }
    function la(a) {
      return C(this, null, function* () {
        h.value = !0, b.value = !0, s.value = {
          customerName: "",
          customerTel: "",
          serviceId: "",
          serviceNo: "",
          orgId: "",
          pageSize: 20,
          pageNo: 1,
          isRelationOrder: 0,
          isTable: 0,
          orderId: "",
          businessType: a.businessType || "business_serviceNo",
          businessId: a.businessId || "",
          customerId: a.customerId || ""
        }, a.serviceId && (s.value.serviceId = a.serviceId), a.serviceNo && (s.value.serviceNo = a.serviceNo), a.code && (w.value.code = a.code), a.disabledOptions !== void 0 && (ge.value = a.disabledOptions), a.disabledSearch !== void 0 && (J.value = a.disabledSearch), a.isRelationOrder && (s.value.isRelationOrder = a.isRelationOrder), a.isTable && (s.value.isTable = a.isTable), a.orderId && (s.value.orderId = a.orderId);
        const e = yield _e();
        T.value = e;
        const l = da("MTDS");
        l.value.length === 0 && (yield new Promise((n) => {
          const I = setTimeout(n, 5e3), O = Ba(l, (R) => {
            R.length > 0 && (clearTimeout(I), O(), n());
          });
        }));
        const t = yield Se("ROOT_MTDS_bpm_special_process_application");
        return ye.value = (t || []).filter((n) => (n.value || n.code) !== "all").map((n) => ({ label: n.label, code: n.value || n.code })), w.value.code && Ce(w.value.code), h.value = !1, Oe(), new Promise((n) => {
          p = n;
        });
      });
    }
    return f({ open: la }), (a, e) => (N(), j(V, null, [
      c("div", {
        ref_key: "triggerContainer",
        ref: z
      }, null, 512),
      r(o(Da), {
        show: b.value,
        "onUpdate:show": e[24] || (e[24] = (l) => b.value = l),
        to: z.value || "body"
      }, {
        default: u(() => [
          r(o(La), { show: h.value }, {
            default: u(() => [
              r(o(Ma), {
                style: { width: "1000px", "max-width": "80vw" },
                title: "发起申请",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: be
              }, {
                default: u(() => {
                  var l;
                  return [
                    c("div", Pa, [
                      r(o(B), {
                        label: "申请类型：",
                        "label-width": 100,
                        size: "small"
                      }, {
                        default: u(() => [
                          r(o(Re), {
                            value: w.value.code,
                            "onUpdate:value": [
                              e[0] || (e[0] = (t) => w.value.code = t),
                              Ce
                            ],
                            options: je.value,
                            placeholder: "请选择",
                            disabled: ge.value,
                            style: { width: "200px" }
                          }, null, 8, ["value", "options", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    w.value.code === "bpm_process_carrier" ? (N(), j(V, { key: 0 }, [
                      e[31] || (e[31] = c("div", { class: "tw:text-red-400 tw:ml-4 tw:mb-2" }, " 温馨提示：选择基地后，点击【查询】才能进行下一步选择收货地址 ", -1)),
                      c("div", Ua, [
                        r(o(B), {
                          label: "基地",
                          "label-width": 100,
                          size: "small"
                        }, {
                          default: u(() => [
                            r(o(Re), {
                              value: i.value.baseCode,
                              options: ie.value,
                              placeholder: "请选择基地",
                              "onUpdate:value": ne,
                              style: { width: "200px" }
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        }),
                        F.value ? S("", !0) : (N(), se(o(y), {
                          key: 0,
                          type: "primary",
                          size: "small",
                          onClick: e[1] || (e[1] = (t) => ee(1, !0))
                        }, {
                          default: u(() => e[25] || (e[25] = [
                            v("查询", -1)
                          ])),
                          _: 1,
                          __: [25]
                        })),
                        F.value ? S("", !0) : (N(), se(o(y), {
                          key: 1,
                          type: "primary",
                          size: "small",
                          onClick: e[2] || (e[2] = (t) => F.value = !0)
                        }, {
                          default: u(() => e[26] || (e[26] = [
                            v("更多筛选", -1)
                          ])),
                          _: 1,
                          __: [26]
                        }))
                      ]),
                      F.value ? (N(), j("div", Aa, [
                        r(o(B), {
                          label: "收货地址",
                          "label-width": 100,
                          size: "small",
                          class: "tw:flex-1"
                        }, {
                          default: u(() => [
                            c("div", Ka, [
                              r(ca, {
                                modelValue: i.value.region,
                                "onUpdate:modelValue": e[3] || (e[3] = (t) => i.value.region = t),
                                isDirectly: !0,
                                class: "tw:flex-1"
                              }, null, 8, ["modelValue"]),
                              r(o(L), {
                                value: i.value.address,
                                "onUpdate:value": e[4] || (e[4] = (t) => i.value.address = t),
                                clearable: ""
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _: 1
                        }),
                        r(o(y), {
                          type: "primary",
                          size: "small",
                          onClick: e[5] || (e[5] = (t) => ee(1, !0))
                        }, {
                          default: u(() => e[27] || (e[27] = [
                            v("查询", -1)
                          ])),
                          _: 1,
                          __: [27]
                        }),
                        r(o(y), {
                          type: "primary",
                          size: "small",
                          onClick: de
                        }, {
                          default: u(() => e[28] || (e[28] = [
                            v("收起", -1)
                          ])),
                          _: 1,
                          __: [28]
                        })
                      ])) : S("", !0),
                      c("div", Oa, [
                        r(o(H), {
                          columns: Ae,
                          data: E.value,
                          bordered: !0,
                          "max-height": 323,
                          "row-key": (t) => t.keyId,
                          "checked-row-keys": ue.value,
                          "onUpdate:checkedRowKeys": We
                        }, null, 8, ["data", "row-key", "checked-row-keys"]),
                        c("div", Wa, [
                          c("span", $a, "共 " + Ie(i.value.total) + " 条", 1),
                          r(o(me), {
                            page: i.value.pageNo,
                            "onUpdate:page": [
                              e[6] || (e[6] = (t) => i.value.pageNo = t),
                              ee
                            ],
                            "page-size": i.value.pageSize,
                            "onUpdate:pageSize": [
                              e[7] || (e[7] = (t) => i.value.pageSize = t),
                              $e
                            ],
                            "item-count": i.value.total,
                            "page-sizes": [10, 20, 50, 100],
                            "show-size-picker": ""
                          }, null, 8, ["page", "page-size", "item-count"])
                        ])
                      ]),
                      i.value.baseCode ? (N(), j("div", Va, [
                        r(o(y), { onClick: be }, {
                          default: u(() => e[29] || (e[29] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [29]
                        }),
                        r(o(y), {
                          type: "primary",
                          onClick: Ve
                        }, {
                          default: u(() => e[30] || (e[30] = [
                            v("确定", -1)
                          ])),
                          _: 1,
                          __: [30]
                        })
                      ])) : S("", !0)
                    ], 64)) : S("", !0),
                    w.value.code === "bpm_process_dsdy_judge" ? (N(), j(V, { key: 1 }, [
                      e[34] || (e[34] = c("h3", { class: "tw:text-base tw:mb-2" }, "选择k3扣费账户", -1)),
                      r(o(H), {
                        columns: De,
                        data: X.value,
                        bordered: !0,
                        "max-height": 250,
                        "row-key": (t) => t.orgMarketManageRightId,
                        "checked-row-keys": G.value,
                        "onUpdate:checkedRowKeys": fe
                      }, null, 8, ["data", "row-key", "checked-row-keys"]),
                      c("div", Ja, [
                        r(o(y), { onClick: K }, {
                          default: u(() => e[32] || (e[32] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [32]
                        }),
                        r(o(y), {
                          type: "primary",
                          onClick: Ge
                        }, {
                          default: u(() => e[33] || (e[33] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [33]
                        })
                      ])
                    ], 64)) : S("", !0),
                    w.value.code === "bpm_process_djjspecial_judge" ? (N(), j(V, { key: 2 }, [
                      c("div", Ga, [
                        ((l = T.value) == null ? void 0 : l.marketId) !== "1" ? (N(), se(o(B), {
                          key: 0,
                          label: "客户姓名",
                          size: "small",
                          "label-width": 80
                        }, {
                          default: u(() => [
                            r(o(L), {
                              value: s.value.customerName,
                              "onUpdate:value": e[8] || (e[8] = (t) => s.value.customerName = t),
                              disabled: J.value,
                              clearable: ""
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })) : S("", !0),
                        r(o(B), {
                          label: "客户电话",
                          size: "small",
                          "label-width": 80
                        }, {
                          default: u(() => [
                            r(o(L), {
                              value: s.value.customerTel,
                              "onUpdate:value": e[9] || (e[9] = (t) => s.value.customerTel = t),
                              disabled: J.value,
                              clearable: ""
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        r(o(B), {
                          label: "服务号",
                          size: "small",
                          "label-width": 80
                        }, {
                          default: u(() => [
                            r(o(L), {
                              value: s.value.serviceNo,
                              "onUpdate:value": e[10] || (e[10] = (t) => s.value.serviceNo = t),
                              disabled: J.value,
                              clearable: ""
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        r(o(y), {
                          type: "primary",
                          size: "small",
                          disabled: J.value,
                          onClick: e[11] || (e[11] = (t) => ae(1))
                        }, {
                          default: u(() => e[35] || (e[35] = [
                            v("搜索", -1)
                          ])),
                          _: 1,
                          __: [35]
                        }, 8, ["disabled"]),
                        s.value.orderId ? (N(), j("span", Fa, e[36] || (e[36] = [
                          c("span", { style: { color: "#d03050" } }, "*", -1),
                          v("是否miform客户：", -1)
                        ]))) : S("", !0),
                        s.value.orderId ? (N(), se(o(za), {
                          key: 2,
                          value: te.value,
                          "onUpdate:value": e[12] || (e[12] = (t) => te.value = t),
                          label: "是否miform客户"
                        }, {
                          default: u(() => [
                            r(o(ze), { value: 0 }, {
                              default: u(() => e[37] || (e[37] = [
                                v("否", -1)
                              ])),
                              _: 1,
                              __: [37]
                            }),
                            r(o(ze), { value: 1 }, {
                              default: u(() => e[38] || (e[38] = [
                                v("是", -1)
                              ])),
                              _: 1,
                              __: [38]
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])) : S("", !0)
                      ]),
                      e[41] || (e[41] = c("div", { class: "tw:mb-2 tw:font-bold" }, [
                        v(" 请在"),
                        c("span", { class: "tw:text-rose-700 tw:mx-1" }, "下单前"),
                        v("发起审批单，审批结束后务必 "),
                        c("span", { class: "tw:text-rose-700 tw:mx-1" }, "在一键下单关联或传单前绑定审批单"),
                        v("，无非标不关联不绑定！ ")
                      ], -1)),
                      r(o(H), {
                        columns: Fe.value,
                        data: pe.value,
                        bordered: !0,
                        "max-height": 400,
                        "row-key": (t) => s.value.businessType === "business_applyCode" ? t.id : t.serviceNo,
                        "checked-row-keys": ce.value,
                        "onUpdate:checkedRowKeys": Ye
                      }, null, 8, ["columns", "data", "row-key", "checked-row-keys"]),
                      c("div", Ya, [
                        r(o(me), {
                          page: s.value.pageNo,
                          "onUpdate:page": [
                            e[13] || (e[13] = (t) => s.value.pageNo = t),
                            ae
                          ],
                          "page-size": s.value.pageSize,
                          "onUpdate:pageSize": [
                            e[14] || (e[14] = (t) => s.value.pageSize = t),
                            Ee
                          ],
                          "item-count": we.value,
                          "show-size-picker": "",
                          "page-sizes": [10, 20, 50]
                        }, null, 8, ["page", "page-size", "item-count"])
                      ]),
                      c("div", Ea, [
                        r(o(y), { onClick: K }, {
                          default: u(() => e[39] || (e[39] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [39]
                        }),
                        r(o(y), {
                          type: "primary",
                          onClick: Qe
                        }, {
                          default: u(() => e[40] || (e[40] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [40]
                        })
                      ])
                    ], 64)) : S("", !0),
                    w.value.code === "bpm_process_relocatebase_judge" ? (N(), j(V, { key: 3 }, [
                      e[44] || (e[44] = c("h4", { class: "tw:text-base tw:mb-2" }, "选择审核人信息", -1)),
                      r(o(H), {
                        columns: Pe,
                        data: X.value,
                        bordered: !0,
                        "max-height": 250,
                        "row-key": (t) => t.orgMarketManageRightId,
                        "checked-row-keys": G.value,
                        "onUpdate:checkedRowKeys": fe
                      }, null, 8, ["data", "row-key", "checked-row-keys"]),
                      c("div", Qa, [
                        r(o(y), { onClick: K }, {
                          default: u(() => e[42] || (e[42] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [42]
                        }),
                        r(o(y), {
                          type: "primary",
                          onClick: qe
                        }, {
                          default: u(() => e[43] || (e[43] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [43]
                        })
                      ])
                    ], 64)) : S("", !0),
                    w.value.code === "bpm_process_baseselfpickup_judge" || w.value.code === "bpm_process_specialshipping_judge" ? (N(), j(V, { key: 4 }, [
                      r(o(Ta), {
                        value: Q.value,
                        "onUpdate:value": [
                          e[21] || (e[21] = (t) => Q.value = t),
                          Xe
                        ],
                        type: "line"
                      }, {
                        default: u(() => [
                          r(o(Te), {
                            name: "retail",
                            tab: "零售单"
                          }, {
                            default: u(() => [
                              c("div", qa, [
                                r(o(B), {
                                  label: "搜索",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: u(() => [
                                    r(o(L), {
                                      value: A.value.searchKeywordByBaseSelfPickup,
                                      "onUpdate:value": e[15] || (e[15] = (t) => A.value.searchKeywordByBaseSelfPickup = t),
                                      placeholder: "客户姓名/电话/主合同号",
                                      clearable: "",
                                      style: { width: "200px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                r(o(B), {
                                  label: "合同自编号",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: u(() => [
                                    r(o(L), {
                                      value: A.value.searchProductionOrderContractNo,
                                      "onUpdate:value": e[16] || (e[16] = (t) => A.value.searchProductionOrderContractNo = t),
                                      placeholder: "合同自编号(批量用中英文逗号或空格隔开)",
                                      clearable: "",
                                      style: { width: "280px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                r(o(y), {
                                  type: "primary",
                                  size: "small",
                                  onClick: e[17] || (e[17] = (t) => oe(1))
                                }, {
                                  default: u(() => e[45] || (e[45] = [
                                    v("搜索", -1)
                                  ])),
                                  _: 1,
                                  __: [45]
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          r(o(Te), {
                            name: "project",
                            tab: "工程单"
                          }, {
                            default: u(() => [
                              c("div", Ha, [
                                r(o(B), {
                                  label: "下单申请号",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: u(() => [
                                    r(o(L), {
                                      value: le.value.applyNo,
                                      "onUpdate:value": e[18] || (e[18] = (t) => le.value.applyNo = t),
                                      placeholder: "下单申请号",
                                      clearable: "",
                                      style: { width: "200px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                r(o(B), {
                                  label: "合同自编号",
                                  size: "small",
                                  "label-width": 80
                                }, {
                                  default: u(() => [
                                    r(o(L), {
                                      value: le.value.searchProductionOrderContractNo,
                                      "onUpdate:value": e[19] || (e[19] = (t) => le.value.searchProductionOrderContractNo = t),
                                      placeholder: "合同自编号(批量用中英文逗号或空格隔开)",
                                      clearable: "",
                                      style: { width: "280px" }
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                r(o(y), {
                                  type: "primary",
                                  size: "small",
                                  onClick: e[20] || (e[20] = (t) => oe(1))
                                }, {
                                  default: u(() => e[46] || (e[46] = [
                                    v("搜索", -1)
                                  ])),
                                  _: 1,
                                  __: [46]
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      c("div", Za, [
                        c("span", null, "已选择 " + Ie(D.value.length) + " 项", 1)
                      ]),
                      r(o(H), {
                        columns: He,
                        data: M.value,
                        bordered: !0,
                        "max-height": 350,
                        "row-key": ke,
                        "checked-row-keys": q.value,
                        "onUpdate:checkedRowKeys": Ze
                      }, null, 8, ["data", "checked-row-keys"]),
                      c("div", Xa, [
                        r(o(me), {
                          page: k.value.pageNo,
                          "onUpdate:page": [
                            e[22] || (e[22] = (t) => k.value.pageNo = t),
                            oe
                          ],
                          "page-size": k.value.pageSize,
                          "onUpdate:pageSize": [
                            e[23] || (e[23] = (t) => k.value.pageSize = t),
                            ea
                          ],
                          "item-count": k.value.total,
                          "show-size-picker": "",
                          "page-sizes": [20, 50, 100]
                        }, null, 8, ["page", "page-size", "item-count"])
                      ]),
                      c("div", et, [
                        r(o(y), { onClick: aa }, {
                          default: u(() => e[47] || (e[47] = [
                            v("取消", -1)
                          ])),
                          _: 1,
                          __: [47]
                        }),
                        r(o(y), {
                          type: "primary",
                          onClick: ta
                        }, {
                          default: u(() => e[48] || (e[48] = [
                            v("发起", -1)
                          ])),
                          _: 1,
                          __: [48]
                        })
                      ])
                    ], 64)) : S("", !0)
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"]),
      r(va, {
        ref_key: "brandCategorySelectorRef",
        ref: P
      }, null, 512)
    ], 64));
  }
});
export {
  At as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/mall-sp-approval-trigger/mallSpApprovalTrigger.ce.vue.js
// module id = 1307
// module chunks = 67